<template>
  <img v-if="lang === 'fr'" src="@/assets/fr.svg" class="flag-icon mr-2" />
  <img v-else-if="lang === 'nl'" src="@/assets/nl.svg" class="flag-icon mr-2" />
  <img v-else-if="lang === 'en'" src="@/assets/en.svg" class="flag-icon mr-2" />
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class LanguageIcon extends Vue {
  @Prop({ type: String, required: true })
  public lang!: "fr" | "nl" | "en";
}
</script>
